
export default {
  props: ['pageData'],
  data() {
    return {
      
    }
  },
  mounted() {
    
  },
  methods: {
    
  }
};
